import React, { useEffect, useState } from "react";
import {
  StyleSheet,
  View,
  Image,
  TouchableOpacity,
  FlatList,
  Dimensions,
  ActivityIndicator,
} from "react-native";
import LinearGradient from "react-native-linear-gradient";
import BackArrow from "@assets/svg/BackArrow";
import ArrowRightSmall from "@assets/svg/ArrowRightSmall";
import MenuIcon from "@assets/svg/MenuIcon";
import Button from "@components/Button";
import GreenStar from "@assets/svg/GreenStar";
import { getReferredCustomersV2 } from "@services/api";
import { getCMSEntityById } from "@services/cmsV2-api";
import { shareOnWhatsapp } from "@utils/shareEntity";
import Text from "@components/CustomText";
import t from "@constants/localization";
import analytics from "@services/analytics";
import { REFER_EARN } from "@constants/analyticsEventsCT";
import { fontFamily } from "@utils/styles/fonts";
import { scale } from "@utils/scale";
import { useSelector } from "react-redux";
import handleCallButtonPress from "@utils/handleCallButtonPress";
import colors from "@constants/color";
import OtherReferModal from "./OtherReferModal";
import NoReferredClComponent from "./NoReferredClComponent";
import ReferralStatusCard from "./ReferralStatusCard";

const PATH = "screens/ReferEarn";

const { height } = Dimensions.get("screen");

const ReferEarn = ({ navigation }) => {
  const [showOtherReferModal, setShowOtherReferModal] = useState();
  const [referredClList, setReferredList] = useState();
  const [isLoading, setLoading] = useState(true);
  const [cmsItems, setCmsItems] = useState();

  const {
    cmsPoweredEntities: { REFERRAL_BG_PAGE, REFERRAL_BG_SMALL_CMS },
  } = useSelector(({ configReducer }) => configReducer.appSettings) || {};

  useEffect(() => {
    Promise.all([
      getCMSEntityById({
        id: REFERRAL_BG_PAGE,
        root: true,
        limit: 10,
      }),
      getCMSEntityById({
        id: REFERRAL_BG_SMALL_CMS,
        root: true,
        limit: 10,
      }),
    ])
      .then((response) => {
        const [
          {
            data: { image_link: cmsReferralBg },
          },
          {
            data: { image_link: cmsReferralBgSmall },
          },
        ] = response;
        setCmsItems({ cmsReferralBg, cmsReferralBgSmall });
        getReferredCustomersV2()
          .then((referredCustomers) => {
            setReferredList(referredCustomers.data);
            setLoading(false);
          })
          .catch((err) => {
            setLoading(false);
            console.log(err);
          });
      })
      .catch(() => {
        setLoading(false);
        getReferredCustomersV2()
          .then((referredCustomers) => {
            setReferredList(referredCustomers.data);
            setLoading(false);
          })
          .catch((err) => {
            setLoading(false);
            console.log(err);
          });
      });
  }, [REFERRAL_BG_PAGE, REFERRAL_BG_SMALL_CMS]);

  const toggleShowOtherReferModal = () => {
    setShowOtherReferModal((value) => !value);
  };

  const handleOnPressReferKare = () => {
    analytics.trackEvent(REFER_EARN.REFER_REFER_NOW, {
      screen: "Refer Main page",
      medium: "Whatsapp",
    });
    shareOnWhatsapp({
      message: referredClList?.referralMetaInfo.waMsg,
      image: referredClList?.referralMetaInfo.waImage,
    });
  };

  const handleOnPressRemindThem = (phoneNumber) => {
    handleCallButtonPress(phoneNumber, REFER_EARN.REFER_CALL_REMINDER, {
      screen: "Refer Main page",
      medium: "Dialer",
    });
  };

  const renderListHeaderComp = () => {
    return (
      <>
        {cmsItems && (
          <Image
            source={{ uri: cmsItems.cmsReferralBgSmall }}
            style={styles.bgImage}
            resizeMode="cover"
          />
        )}
        <LinearGradient
          style={styles.bgGradient1}
          colors={["rgba(0, 0, 0, 0)", "rgba(0, 0, 0, 1)"]}
        >
          <View style={styles.header}>
            <TouchableOpacity
              style={styles.backButton}
              onPress={() => navigation.goBack()}
            >
              <BackArrow color="#fff" />
            </TouchableOpacity>
            <TouchableOpacity
              style={styles.menuButton}
              onPress={toggleShowOtherReferModal}
            >
              <MenuIcon color="#fff" />
            </TouchableOpacity>
          </View>
          <View style={styles.upperContent}>
            <Text variant="title_18_regular" style={styles.titleText}>
              {t(`${PATH}/earnThroughReferal`)}
            </Text>
            <Text variant="title_44" style={styles.amountText}>
              ₹
              <Text style={{ fontSize: 50, marginVertical: 0 }}>
                {referredClList?.referralMetaInfo.amount}
              </Text>
            </Text>
          </View>
          <TouchableOpacity
            style={styles.getToKnowButton}
            onPress={() =>
              navigation.navigate("ReferEarnStepsScreen", {
                wa: {
                  waMsg: referredClList?.referralMetaInfo.waMsg,
                  waImage: referredClList?.referralMetaInfo.waImage,
                },
              })
            }
          >
            <Text variant="caption_1" style={styles.getToKnowText}>
              {t(`${PATH}/stepsToKnow`)}
            </Text>
            <View style={styles.whiteCircle}>
              <ArrowRightSmall color="#000" />
            </View>
          </TouchableOpacity>
        </LinearGradient>
        <View style={styles.metaDataContainer}>
          <View
            style={{ flexDirection: "row", justifyContent: "space-between" }}
          >
            <Text variant="caption_1" style={styles.metaTitleText}>
              {t(`${PATH}/yourReferral`)}
            </Text>
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <Text variant="caption_1" style={styles.metaAmountTitleText}>
                {t(`${PATH}/totalIncome`)}
              </Text>
              <Text variant="subtitle_20" style={styles.metaAmountText}>
                ₹{referredClList?.referralMetaInfo.totalAmountEarned}
              </Text>
            </View>
          </View>
          <View style={{ flexDirection: "row" }}>
            <GreenStar />
            <Text variant="caption_2" style={styles.metaTotalReferredText}>
              {referredClList?.referredCustomers.length}{" "}
              {t(`${PATH}/totalRefferalToFriends`)}
            </Text>
          </View>
        </View>
      </>
    );
  };

  return (
    <View style={styles.container}>
      {isLoading && (
        <View style={styles.loaderContainer}>
          <ActivityIndicator color={colors.primary} size="large" />
        </View>
      )}
      {referredClList?.referredCustomers.length === 0 && (
        <NoReferredClComponent
          amount={referredClList?.referralMetaInfo.amount}
          toggleShowOtherReferModal={toggleShowOtherReferModal}
          referKare={handleOnPressReferKare}
          backgroundImage={cmsItems.cmsReferralBg}
          wa={{
            waMsg: referredClList?.referralMetaInfo.waMsg,
            waImage: referredClList?.referralMetaInfo.waImage,
          }}
        />
      )}
      {referredClList?.referredCustomers.length > 0 && (
        <>
          <FlatList
            data={referredClList?.referredCustomers}
            ListHeaderComponent={renderListHeaderComp()}
            renderItem={({ item, index }) => (
              <ReferralStatusCard
                key={index}
                name={item.user_name}
                phoneNumber={item.user_phone}
                amount={item.amount}
                referralCommissionProcessed={item.referral_commission_processed}
                remember={handleOnPressRemindThem}
                steps={item.steps}
              />
            )}
          />
          <View style={styles.ctaContainer}>
            <Button
              buttonWidth="100%"
              btnText={t(`${PATH}/referNow`)}
              buttonFontType="head1"
              height={56}
              borderRadius={10}
              onPress={handleOnPressReferKare}
            />
          </View>
        </>
      )}
      {showOtherReferModal && (
        <OtherReferModal
          show={showOtherReferModal}
          close={toggleShowOtherReferModal}
          referralLink={referredClList?.referralMetaInfo.cdn_url}
          phoneNumber={referredClList?.referralMetaInfo.phoneNumber}
        />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  loaderContainer: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  bgImage: {
    width: "100%",
    height: height / 2,
    position: "absolute",
    top: 0,
    borderBottomLeftRadius: 20,
    borderBottomRightRadius: 20,
  },
  header: {
    padding: 5,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  backButton: {
    padding: 15,
    borderRadius: 10,
  },
  menuButton: {
    padding: 15,
    height: 42,
    width: 42,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 32,
    backgroundColor: "rgba(255, 255, 255, 0.2)",
    marginTop: 5,
  },
  bgGradient1: {
    height: height / 2,
    borderBottomLeftRadius: 20,
    borderBottomRightRadius: 20,
    elevation: 5,
  },
  upperContent: {
    padding: 0,
    marginTop: "20%",
  },
  titleText: {
    fontSize: scale(25),
    marginHorizontal: 20,
    color: "#FFF6C8",
    fontWeight: "700",
    textAlign: "center",
  },
  metaDataContainer: {
    padding: 10,
    backgroundColor: "#fff",
    justifyContent: "center",
  },
  metaTitleText: {
    fontSize: 18,
    fontWeight: "700",
    lineHeight: 28,
    color: "rgba(0, 0, 0, 0.86)",
  },
  metaAmountTitleText: {
    fontSize: 14,
    color: "rgba(0, 0, 0, 0.86)",
    fontWeight: "700",
    marginRight: 10,
    lineHeight: 26,
  },
  metaAmountText: {
    color: "rgba(39, 174, 96, 1)",
    fontSize: 20,
    fontWeight: "600",
  },
  metaTotalReferredText: {
    fontSize: 12,
    fontWeight: "600",
    color: "rgba(0, 0, 0, 0.86)",
    marginLeft: 5,
  },
  amountText: {
    fontSize: 55,
    color: "#FFF6C8",
    fontWeight: "500",
    textAlign: "center",
    fontFamily: fontFamily.bold,
    lineHeight: 70,
  },
  getToKnowText: {
    fontSize: 16,
    color: "#fff",
    fontWeight: "700",
    textAlign: "center",
  },
  getToKnowButton: {
    padding: 10,
    flexDirection: "row",
    justifyContent: "center",
  },
  whiteCircle: {
    width: 20,
    height: 20,
    backgroundColor: "white",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 20,
    marginLeft: 5,
  },
  ctaContainer: {
    width: "100%",
    backgroundColor: "transparent",
    padding: 15,
  },
});

export default ReferEarn;
